import {JsonProperty} from 'json-typescript-mapper';
import {Contact} from './contact.model';

export class ContactLog {

  public static ACTION_TYPE_BAN_MERCHANT_FROM_MARKETWEBSITE = 'BAN_MERCHANT_FROM_MARKETWEBSITE';
  public static ACTION_TYPE_UNBAN_MERCHANT_FROM_MARKETWEBSITE = 'UNBAN_MERCHANT_FROM_MARKETWEBSITE';

  @JsonProperty('id')
  public id?: number;

  @JsonProperty('created')
  public created?: string;

  @JsonProperty('actionType')
  public actionType?: string;

  @JsonProperty('message')
  public message?: string;

  @JsonProperty('createdBy')
  public createdBy?: Contact;

  @JsonProperty('contact')
  public contact?: Contact;

  constructor() {
  this.id =  void 0;
  this.created = void 0;
  this.actionType = void 0;
  this.message = void 0;
  this.createdBy = void 0;
  this.contact = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/contact-log.model.ts